import { css } from '@/styled-system/css';

export const inlineFeedbackRootStyles = css.raw({
  display: 'inline-flex',
  alignItems: 'flex-start',
  gap: 'default',
});
